import { useQuery } from '@apollo/client';
import { useRouter } from '@application/utils';
import { graphql } from '@gql/gql';
import type { MtApplicationBreederGetApplicationQueryVariables } from '@gql/graphql';
import { DogBreederApplicationStatus } from '@gql/graphql';
import { useMemo } from 'react';

export const MT_APPLICATION_BREEDER_GET_APPLICATION = graphql(`
  query MtApplicationBreederGetApplication(
    $applicationWhere: DogBreederApplicationWhereInput
    $breedTranslationWhere: DogBreedTranslationWhereInput
  ) {
    accountMe {
      id
      address {
        country
      }

      dogBreeder {
        id

        breederBreeds {
          dogBreedId
        }

        applications(take: 1, where: $applicationWhere) {
          id
          createdAt
          accommodation
          experiences
          timeAlone
          trainers
          genderPreferences
          otherPreferences
          status
          motive
          otherAnimals
          questions
          seenByBreeder

          breedPreference {
            id

            imgs(take: 1, where: { type: { equals: MAIN } }) {
              id
              small
            }

            translations(take: 1, where: $breedTranslationWhere) {
              id
              name
            }
          }

          account {
            id
            firstName
            lastName
            phone
            email
            address {
              country
            }
          }

          animal {
            id
            name
            birthday
          }
        }
      }
    }
  }
`);

export const useGetApplication = (id: number) => {
  const { language } = useRouter();

  const variables = useMemo((): MtApplicationBreederGetApplicationQueryVariables => {
    return {
      applicationWhere: {
        id: { equals: id },
        status: {
          notIn: [DogBreederApplicationStatus.DRAFT, DogBreederApplicationStatus.NONE],
        },
      },
      breedTranslationWhere: { language: { equals: language } },
    };
  }, [id, language]);

  const { data, loading } = useQuery(MT_APPLICATION_BREEDER_GET_APPLICATION, { variables });

  return {
    application: data,
    applicationLoading: loading,
  };
};
